export const environment = {
  production: true,
  buildId: '2894800202419711',
  configFile: 'config.json',
};
